import { FC } from 'react';
import { clsx } from 'clsx';
import { useAppSelector } from 'shared/lib';

import { makeDateCards } from '../lib';
import { IDateRowProps } from '../models/types';

import styles from './styles.module.scss';

export const DateRow: FC<IDateRowProps> = ({ isScrolledDown, data }) => {
  const { startIntervalDate, endIntervalDate } = useAppSelector(
    (state) => state.schedulePublicReducer,
  );
  return (
    <div
      className={clsx(styles['date-row'], {
        [styles['date-row_scrolled']]: isScrolledDown,
      })}
    >
      {makeDateCards(data, startIntervalDate, endIntervalDate, isScrolledDown)}
    </div>
  );
};
